/** Ancho del panel lateral para ítems/PDF de cotización (cotizaciones y ventas). */
export const QUOTATION_PREVIEW_SIDE_PANEL_WIDTH = 800;
